export const ENV_NAME = 'development';
export const DISABLE_ANALYTICS = true;
export const BASE_URL = 'http://localhost:3000/';
export const BASE_WS_URL = 'ws://localhost:3010';
export const CLOUD_PROVIDER = 'aws'; // aws | azure
export const S3_PUBLIC_BUCKET_URL = 'https://s3-us-west-2.amazonaws.com/op-dev-public/';
export const TURNSTYLE_SITE_KEY = '0x4AAAAAAAGsihvHw0KcRK5d';
// export const TURNSTYLE_SITE_KEY = '1x00000000000000000000AA';
export const USE_OKTA = false;
